import { FieldValue } from '@/types'
import { Autocomplete, TextField } from '@mui/material'
import { memo } from 'react'

type AutoCompleteDropdownProps = {
  id: string
  value: FieldValue
  isHidden: boolean
  onChangeHandler: (val: FieldValue, fieldId: string, isLabel?: boolean) => void
  options?: string[]
  placeholder?: string
}

const AutoCompleteDropdown: React.FC<AutoCompleteDropdownProps> = ({ id, value, onChangeHandler, options = [], placeholder }) => {
  return (
    <Autocomplete
      freeSolo
      disablePortal
      fullWidth
      options={options}
      value={value}
      onInputChange={(event, newValue) => onChangeHandler(newValue, id)}
      onChange={(event, newValue) => onChangeHandler(newValue, id)}
      renderInput={(params) => <TextField {...params} placeholder={placeholder} fullWidth hiddenLabel size="small" />}
    />
  )
}

export default memo(AutoCompleteDropdown)
